import { Route, Routes } from 'react-router-dom';
import { PersonalizationSummaryPublicPage } from './Public/PersonalizationSummaryPublicPage';

export function PublicPages() {
  return (
    <Routes>
      <Route
        path="/personalization-summary/:id"
        element={<PersonalizationSummaryPublicPage />}
      />
    </Routes>
  );
}
